/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Last_Bill_Detail_StorageInputs */

const es_admin_billing_last_bill_detail_storage = /** @type {(inputs: Admin_Billing_Last_Bill_Detail_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storage`)
};

const en_admin_billing_last_bill_detail_storage = /** @type {(inputs: Admin_Billing_Last_Bill_Detail_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storage`)
};

/**
* | output |
* | --- |
* | "Storage" |
*
* @param {Admin_Billing_Last_Bill_Detail_StorageInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_last_bill_detail_storage = /** @type {((inputs?: Admin_Billing_Last_Bill_Detail_StorageInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Last_Bill_Detail_StorageInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_last_bill_detail_storage(inputs)
	return en_admin_billing_last_bill_detail_storage(inputs)
});
export { admin_billing_last_bill_detail_storage as "admin.billing.last_bill.detail_storage" }